module.exports = __webpack_public_path__ + "static/media/web-icn.d2015b6a.svg";